export const rateLimits = {
  // mathMax: eg: to prevent /0.
  // override: the "alternate" default.
  // maxMarginProtection currently == max (50).
  land: { min: 0, max: 50, mathMax: 99, default: 20, override: 3, marginProtectionMin: 20, marginProtectionDefault: 20 },
  air: { min: 0, max: 50, mathMax: 99, default: 20, override: 3, marginProtectionMin: 20, marginProtectionDefault: 20 },
  deposit: { min: 0, max: 100, default: 50, override: 3, marginProtectionMin: 18, marginProtectionDefault: 50 },
  currency: { min: 0, max: 50, mathMax: 99, default: 3 },
  dmc: { min: 0, max: 50, default: 3, override: 20, marginProtectionMin: 18, marginProtectionDefault: 18 },
  rack: { min: 0, max: 50, default: 6 },

  credit: { default: 3.5 },
  ach: { default: 1.5 },
  foreignSell: { default: 1 },
};
